// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jpmo2HAIG7e2Jz21HrpE {
	display: flex;
	align-items: center;
	white-space: pre-wrap;
}

.VO7YBu77WHBnb6ZlEFmI {
	margin-left: 6px;
}

.m_ij8crXkNgmYpp9XBaE {
	visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/SISAmountInput/Balance.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB","sourcesContent":[".container {\n\tdisplay: flex;\n\talign-items: center;\n\twhite-space: pre-wrap;\n}\n\n.spinner {\n\tmargin-left: 6px;\n}\n\n.hidden {\n\tvisibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `jpmo2HAIG7e2Jz21HrpE`,
	"spinner": `VO7YBu77WHBnb6ZlEFmI`,
	"hidden": `m_ij8crXkNgmYpp9XBaE`
};
export default ___CSS_LOADER_EXPORT___;
